import { render } from "./crash2Home.vue?vue&type=template&id=fef510ee&scoped=true"
import script from "./crash2Home.vue?vue&type=script&lang=js"
export * from "./crash2Home.vue?vue&type=script&lang=js"

import "./crash2Home.vue?vue&type=style&index=0&id=fef510ee&scoped=true&lang=css"
import "./crash2Home.vue?vue&type=style&index=1&id=fef510ee&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef510ee"]])

export default __exports__